export default __webpack_public_path__ + "static/media/contact-form.dd0c553e.svg";